export default __webpack_public_path__ + "static/media/azure-app-service.7e748bb8.svg";